import React from 'react';
import { Route } from 'react-router-dom';
import StaffDashboard from '@/pages/StaffDashboard';
import EnhancedStaffDashboard from '@/pages/EnhancedStaffDashboard';
import PatientManagement from '@/pages/staff/PatientManagement';
import PatientDetail from '@/pages/staff/PatientDetail';
import PatientAppointments from '@/pages/staff/PatientAppointments';
import PatientCredits from '@/pages/staff/PatientCredits';
import PaymentProcessing from '@/pages/staff/PaymentProcessing';
import StaffTreatments from '@/pages/staff/StaffTreatments';
import StaffReports from '@/pages/staff/StaffReports';
import StaffSettings from '@/pages/staff/StaffSettings';

export const StaffRoutes = () => (
  <>
    {/* Main Staff Portal Route */}
    <Route path="/staff" element={<StaffDashboard />} />
    
    {/* Staff Portal */}
    <Route path="/staff/dashboard" element={<StaffDashboard />} />
    <Route path="/staff/dashboard/enhanced" element={<EnhancedStaffDashboard />} />
    
    {/* Staff Patients */}
    <Route path="/staff/patients" element={<PatientManagement />} />
    <Route path="/staff/patients/:id" element={<PatientDetail />} />
    <Route path="/staff/patients/:id/appointments" element={<PatientDetail />} />
    <Route path="/staff/patients/:id/credits" element={<PatientDetail />} />
    <Route path="/staff/patients/:id/treatments" element={<PatientDetail />} />
    <Route path="/staff/patients/:id/notes" element={<PatientDetail />} />

    {/* Staff Appointments */}
    <Route path="/staff/appointments" element={<PatientAppointments />} />
    <Route path="/staff/appointments/new" element={<PatientAppointments />} />
    <Route path="/staff/appointments/:id" element={<PatientAppointments />} />

    {/* Staff Credits */}
    <Route path="/staff/credits" element={<PatientCredits />} />
    <Route path="/staff/credits/add" element={<PatientCredits />} />
    <Route path="/staff/credits/adjust" element={<PatientCredits />} />

    {/* Staff Payments */}
    <Route path="/staff/payments" element={<PaymentProcessing />} />
    <Route path="/staff/payments/new" element={<PaymentProcessing />} />

    {/* Staff Treatments */}
    <Route path="/staff/treatments" element={<StaffTreatments />} />
    <Route path="/staff/treatments/new" element={<StaffTreatments />} />
    <Route path="/staff/treatments/:slug/edit" element={<StaffTreatments />} />

    {/* Staff Reports */}
    <Route path="/staff/reports" element={<StaffReports />} />
    <Route path="/staff/reports/revenue" element={<StaffReports />} />
    <Route path="/staff/reports/memberships" element={<StaffReports />} />
    <Route path="/staff/reports/referrals" element={<StaffReports />} />
    <Route path="/staff/reports/no-shows" element={<StaffReports />} />

    {/* Staff Settings */}
    <Route path="/staff/settings" element={<StaffSettings />} />
    <Route path="/staff/settings/treatments" element={<StaffSettings />} />
    <Route path="/staff/settings/memberships" element={<StaffSettings />} />
    <Route path="/staff/settings/roles" element={<StaffSettings />} />
    <Route path="/staff/settings/integrations" element={<StaffSettings />} />
    <Route path="/staff/settings/permissions" element={<StaffSettings />} />
    <Route path="/staff/settings/locations" element={<StaffSettings />} />

    {/* Staff Locations */}
    <Route path="/staff/locations" element={<StaffSettings />} />
  </>
);
